/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import type { Params } from 'react-router-dom';

import { getIntercomUserCredentials } from '@fai/friendli-suite/features/routes/loaders/apis/intercom';
import { INTERCOM_APP_ID } from '@fai/friendli-suite/shared/intercom/id';

export const updateIntercomUser = async ({ params }: { params: Params<'teamId'> }) => {
  const userCredentials = await getIntercomUserCredentials({
    teamId: params.teamId ?? '',
  });

  // NOTE: BE gives '-' if user is not identified because hmac and external_id is composed as `${email}-${teamId}`
  if (typeof window.Intercom === 'function') {
    window.Intercom('update', {
      api_base: 'https://api-iam.intercom.io',
      app_id: INTERCOM_APP_ID,
      team_id: params.teamId,
      user_id:
        userCredentials?.icIdentityHmac.externalId !== '-'
          ? userCredentials?.icIdentityHmac.externalId
          : undefined,
      user_hash:
        userCredentials?.icIdentityHmac.hmac !== '-'
          ? userCredentials?.icIdentityHmac.hmac
          : undefined,
      name: userCredentials?.name ?? undefined,
      email: userCredentials?.email ?? undefined,
    });
  }

  return null;
};
